import { __assign, __decorate, __extends } from "tslib";
import * as React from 'react';
import { dtoToSolutionPageProps, SolutionPage, SolutionPageCtx } from '.';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import { getSolutionBySlug, getSolutionPreviewBySlugOrId } from '../../api/api';
import { biLogger } from '../../bi';
import { config } from '../../config';
import s from './solution-page-views/solution-page.scss';
import { PreviewMode } from './preview-elements';
import { HeaderContext } from './solution-page-views/solution-page-header/header-context';
import { SolutionPageHeader } from './solution-page-views/solution-page-header/solution-page-header';
import { dtoToDetailsProps } from './solution-page-views';
import { AppPageMode, Origin, Path } from '../..';
import { WithFetcher, } from '../../component-decorators/with-fetcher';
import { createTestAppData } from './test-app-defaults';
import { composer } from '../../component-decorators/composer';
import { CenteredLoader } from '../centered-loader';
import { SolutionPageSEO } from './solution-page-seo';
import { getPathForBi, getReferralInfo, getWidgetReferral, } from '../../common/bi-events';
import { useConfigContext } from '../../config-context';
import { ErrorPageContainer } from '../error-page/error-page-container';
var SolutionPageContainerLogic = /** @class */ (function (_super) {
    __extends(SolutionPageContainerLogic, _super);
    function SolutionPageContainerLogic(props) {
        var _this = _super.call(this, props) || this;
        _this.showHeader = function () {
            _this.setState({ showHeader: true });
        };
        _this.hideHeader = function () {
            _this.setState({ showHeader: false });
        };
        _this.state = { showHeader: false };
        console.log("marketplace-component/src/components/solution-page/solution-page-container.tsx file - line 59 - " + Date.now());
        return _this;
    }
    SolutionPageContainerLogic.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        prevProps.slug !== this.props.slug &&
            this.props.reFetch(function () {
                return getData(_this.props.t, _this.props.slug, _this.props.mode, _this.props.previewLangCode, _this.props.locale, _this.props.experiments &&
                    _this.props.experiments.enabled('specs.marketplace.newMarketApi'));
            });
        prevProps.fetchData !== this.props.fetchData &&
            this.sendPageViewBi(this.props.fetchData);
    };
    SolutionPageContainerLogic.prototype.componentDidMount = function () {
        this.props.fetchData && this.sendPageViewBi(this.props.fetchData);
    };
    SolutionPageContainerLogic.prototype.render = function () {
        var prevRoute = this.props.marketplaceStore.prevRoute;
        var addAppStickyStripPosition = 'top';
        var positionTop = '-73px';
        console.log("marketplace-component/src/components/solution-page/solution-page-container.tsx file - line 101 - " + Date.now());
        return (React.createElement("div", null,
            addAppStickyStripPosition === 'top' ? (React.createElement(SolutionPageHeader, __assign({}, dtoToDetailsProps(this.props.fetchData), { show: this.state.showHeader, position: "top", isMobile: this.props.isMobile }))) : null,
            React.createElement("div", { style: { position: 'relative', top: positionTop }, "data-testid": "solution-" + this.props.slug },
                React.createElement("div", null,
                    React.createElement(HeaderContext.Provider, { value: {
                            showHeader: this.showHeader,
                            hideHeader: this.hideHeader,
                        } },
                        React.createElement("div", { className: s.backgroundSolutionPage },
                            React.createElement(PreviewMode.Provider, { value: {
                                    appId: this.props.fetchData.baseInfo.id,
                                    isPreview: this.props.mode === AppPageMode.PREVIEW,
                                } },
                                React.createElement(SolutionPageCtx.Provider, { value: { app: this.props.fetchData } },
                                    React.createElement(SolutionPage, __assign({}, dtoToSolutionPageProps(this.props.fetchData, prevRoute, this.props.mode)))))))))));
    };
    SolutionPageContainerLogic.prototype.sendPageViewBi = function (solutionDto) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        // tslint:disable-next-line: no-floating-promises
        var pageViewParams = {
            app_id: solutionDto.baseInfo.id,
            esi: config.esi,
            market: config.originForBI,
            navigation_source: this.props.marketplaceStore.route.referral || '',
            tag_type: getPathForBi(Path.WEB_SOLUTION),
            referral_info: getReferralInfo(this.props.marketplaceStore.route &&
                this.props.marketplaceStore.route.referral, this.props.marketplaceStore.prevRoute),
            search_term: this.props.marketplaceStore.prevRoute &&
                this.props.marketplaceStore.prevRoute.query,
            widget_referral: getWidgetReferral(),
            referral_section_index: (_b = (_a = this.props.marketplaceStore) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.appIndex,
            referral_section_name: ((_d = (_c = this.props.marketplaceStore) === null || _c === void 0 ? void 0 : _c.route) === null || _d === void 0 ? void 0 : _d.referralSectionName) ? (_f = (_e = this.props.marketplaceStore) === null || _e === void 0 ? void 0 : _e.route) === null || _f === void 0 ? void 0 : _f.referralSectionName : (_h = (_g = this.props.marketplaceStore) === null || _g === void 0 ? void 0 : _g.route) === null || _h === void 0 ? void 0 : _h.referral,
            slug_id: (_k = (_j = this.props.marketplaceStore) === null || _j === void 0 ? void 0 : _j.route) === null || _k === void 0 ? void 0 : _k.referralSectionName,
            referral_tag_name: (_m = (_l = this.props.marketplaceStore) === null || _l === void 0 ? void 0 : _l.route) === null || _m === void 0 ? void 0 : _m.referralTag,
            collimp_id: (_p = (_o = this.props.marketplaceStore) === null || _o === void 0 ? void 0 : _o.route) === null || _p === void 0 ? void 0 : _p.collimp_id,
            section: (_r = (_q = this.props.marketplaceStore) === null || _q === void 0 ? void 0 : _q.route) === null || _r === void 0 ? void 0 : _r.section,
        };
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketPageView(pageViewParams);
    };
    SolutionPageContainerLogic = __decorate([
        withMarketplaceStore
    ], SolutionPageContainerLogic);
    return SolutionPageContainerLogic;
}(React.Component));
var getData = function (t, slug, mode, previewLangCode, locale, useNewApi, rpcClient) {
    if (mode === AppPageMode.TEST) {
        return getSolutionPreviewBySlugOrId(slug, previewLangCode, useNewApi, rpcClient).then(function (data) {
            return createTestAppData(t, data);
        });
    }
    if (mode === AppPageMode.PREVIEW) {
        return getSolutionPreviewBySlugOrId(slug, previewLangCode, useNewApi, rpcClient).then(function (data) { return data; });
    }
    return getSolutionBySlug(slug, locale, useNewApi, rpcClient);
};
export var SolutionPageContainer = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (props) {
    // tslint:disable-next-line: react-hooks-nesting
    var _a = useConfigContext(), locale = _a.locale, isMobile = _a.isMobile, rpcClient = _a.rpcClient;
    console.log("marketplace-component/src/components/solution-page/solution-page-container.tsx file - line 210 - " + Date.now());
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: function () {
            return getData(props.t, props.slug, props.mode, props.previewLangCode, locale, props.experiments &&
                props.experiments.enabled('specs.marketplace.newMarketApi'), rpcClient);
        }, fetchMemoizationId: "solution-" + props.slug + "-" + locale }, function (_a) {
        var fetchData = _a.fetchData, reFetch = _a.reFetch;
        if (fetchData && fetchData.baseInfo) {
            return (React.createElement(React.Fragment, null,
                config.origin === Origin.STANDALONE &&
                    props.mode !== AppPageMode.TEST &&
                    props.mode !== AppPageMode.PREVIEW && (React.createElement(SolutionPageSEO, { appName: fetchData.baseInfo.name, teaser: fetchData.baseInfo.teaser, logo: fetchData.baseInfo.icon, appSlug: props.slug })),
                React.createElement(SolutionPageContainerLogic, __assign({}, props, { fetchData: fetchData, reFetch: reFetch, locale: locale, isMobile: isMobile }))));
        }
        return React.createElement(ErrorPageContainer, { slug: props.slug });
    }));
});
//# sourceMappingURL=solution-page-container.js.map